<wb-button-group>
  <!--   TEST DEFINITION RUN -->
<!--   <wb-tooltip position="top" *ngIf="showTestDefRunCancel">
    <wb-button size="m" variant="tertiary" (click)="cancelClicked()">
      Cancel
    </wb-button>
    <div slot="content">Cancel {{ toolTip }} Run</div>
  </wb-tooltip> -->

  <wb-tooltip position="top" *ngIf="showTestDefRunDownload">
    <wb-round-button size="m" (click)="downloadClicked()">
      <wb-icon class="icon-color" name="bds/download/24"></wb-icon>
      Details
    </wb-round-button>
    <div slot="content">Download {{ toolTip }} Report</div>
  </wb-tooltip>
  <wb-tooltip position="top" *ngIf="showTerminateTestBench">
    <wb-button size="m" variant="tertiary" (click)="terminateClicked()">     
      Terminate
    </wb-button>
    <div slot="content">Terminate Remote Testbench</div>
  </wb-tooltip> 
  <wb-tooltip position="right" *ngIf="showStartTestBench">
    <wb-button size="m" variant="tertiary" (click)="startClicked()">     
      Start
    </wb-button>
    <div slot="content">Start Remote Testbench</div>
  </wb-tooltip> 
  <wb-tooltip position="right" *ngIf="showStopTestBench">
    <wb-button size="m" variant="tertiary" (click)="stopClicked()">     
      Stop
    </wb-button>
    <div slot="content">Stop Remote Testbench</div>
  </wb-tooltip> 
</wb-button-group>
